import { AffiliateApi } from "@/api/affiliates";
import { GetAffiliateUsersRequest } from "@/api/affiliates/types";
import { QueryKey } from "@/utils";
import { useQuery } from "@tanstack/react-query";

export const useGetAffiliates = ({
  page,
  perPage,
  sortBy,
  sortDirection,
}: Pick<
  GetAffiliateUsersRequest,
  "page" | "perPage" | "sortBy" | "sortDirection"
>) => {
  const { data, isError, isFetching } = useQuery({
    queryKey: [QueryKey.AFFILIATES, { page, perPage, sortBy, sortDirection }],
    queryFn: () =>
      AffiliateApi.getAffiliateUsers({ page, perPage, sortBy, sortDirection }),
    select: ({ data: affiliates }) => {
      if (affiliates.length === 0) return undefined;

      const baseEarnings = affiliates[0].earnings;

      return affiliates.map((affiliate) => ({
        ...affiliate,
        earningsPercent:
          baseEarnings === 0 ? 0 : (affiliate.earnings / baseEarnings) * 100,
      }));
    },
  });

  return {
    affiliates: data,
    affiliatesError: isError,
    isAffiliatesLoading: isFetching,
  };
};
